(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* --- Color dot click: swap image, title, price without reload --- */
  document.addEventListener("click", function (e) {
    var dot = e.target.closest(".color-dot");
    if (!dot) return;
    var card = dot.closest(".pcard, [data-pcard]");
    if (!card) return;
    var newImage = dot.dataset.image;
    var newTitle = dot.dataset.title;
    var newPrice = dot.dataset.price;
    var newUrl = dot.dataset.url;
    var newHandle = newUrl.split('/products/')[1];

    var mediaLink = card.querySelector(".pcard__media-link");
    if (mediaLink) {
      mediaLink.innerHTML = '<img src="' + newImage + '" alt="' + newTitle + '" style="width:100%;height:100%;object-fit:cover;">';
      mediaLink.href = newUrl;
    }

    var title = card.querySelector(".pcard__name");
    if (title) { title.textContent = newTitle; title.href = newUrl; }

    var price = card.querySelector(".pcard__price");
    if (price) { price.innerHTML = newPrice; }

    var atcBtn = card.querySelector(".pcard__atc-btn");
    if (atcBtn && newHandle) {
      atcBtn.setAttribute('onclick', "window.openQuickAdd && openQuickAdd('" + newHandle + "')");
    }

    card.querySelectorAll("a[href]").forEach(function(a) {
      if (!a.classList.contains("color-dot") && !a.closest(".pcard__colors")) {
        a.href = newUrl;
      }
    });
  });

  /* --- Mobile swipe dots --- */
  document.querySelectorAll('[data-pcard-swipe]').forEach(function (swipe) {
    var card = swipe.closest('[data-pcard]');
    if (!card) return;
    var dots = card.querySelectorAll('[data-dot]');
    if (!dots.length) return;

    var slides = swipe.querySelectorAll('.pcard__slide');
    var current = 0;

    swipe.addEventListener('scroll', function () {
      var scrollLeft = swipe.scrollLeft;
      var slideWidth = swipe.offsetWidth;
      var index = Math.round(scrollLeft / slideWidth);
      if (index !== current && index >= 0 && index < slides.length) {
        dots[current].classList.remove('pcard__dot--active');
        current = index;
        dots[current].classList.add('pcard__dot--active');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
